import { Action, createReducer, on } from '@ngrx/store';
import { EventTotalTabMode } from 'mbs-ui-shared@components/sidepanel-rmm/event-total-tab/event-total-tab.model';
import { getISOStrings, isLastTimeOfDate } from 'mbs-ui-shared@components/sidepanel-rmm/event-total-tab/event-total-tab.utils';
import { EventLogEntryTypeEnum, EventLogTypesEnum } from 'mbs-ui-shared@models/rmm/EventLogInfo';
import moment from 'moment';
import * as EventTotalActions from './event-total.actions';

export const eventTotalFeatureKey = 'eventTotal';

export interface State {
  date: Date;
  entry: EventLogEntryTypeEnum;
  hid: string;
  logType: EventLogTypesEnum;
  mode: EventTotalTabMode;
  online: boolean;
  start: string;
  stop: string;
  utcOffset: number;
}

export const initialState: State = {
  date: new Date(),
  entry: null,
  hid: null,
  logType: EventLogTypesEnum.Application,
  mode: EventTotalTabMode.CHART,
  online: null,
  start: moment(new Date()).utc().subtract(24, 'hours').toISOString(),
  stop: moment(new Date()).utc().toISOString(),
  utcOffset: 0
};

const reducer = createReducer(
  initialState,
  on(EventTotalActions.UpdateDate, (state, { date }) => {
    if (isLastTimeOfDate(state.date, date, state.stop)) {
      return state;
    } else {
      const { start, stop } = getISOStrings(state.utcOffset)(date);
      return Object.assign({}, state, { date, start, stop });
    }
  }),
  on(EventTotalActions.ChangeMode, (state, { mode }) => {
    if (mode === undefined) {
      mode = Number(!state.mode);
    }

    return Object.assign({}, state, { mode, logType: EventLogTypesEnum.Application, entry: null });
  }),
  on(EventTotalActions.UpdateType, (state, { logType }) => {
    return Object.assign({}, state, { logType, mode: EventTotalTabMode.GRID, entry: null });
  }),
  on(EventTotalActions.ViewLogByEntryType, (state, { logType, entry }) => {
    return Object.assign({}, state, { logType, mode: EventTotalTabMode.GRID, entry });
  }),
  on(EventTotalActions.UpdateHost, (_state, action) => {
    return Object.assign({}, initialState, action);
  }),
  on(EventTotalActions.ClearEventTotal, () => {
    return Object.assign({}, initialState);
  })
);

export function eventTotalReducer(state: State | undefined, action: Action) {
  return reducer(state, action);
}
